var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMedicalCourse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC65-Student-Management",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Student-Management-/-Student-Profile-/-Reports-Package-3",
    transform: "translate(-568.000000, -288.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stats-1",
    transform: "translate(96.000000, 264.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PN-Copy-2",
    transform: "translate(448.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(24.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Copy-2",
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Base",
    fill: "#6A3663",
    cx: 24,
    cy: 24,
    r: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Laptop",
    transform: "translate(12.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1.77635684e-15,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("g", {
    id: "laptop-medical",
    transform: "translate(0.400000, 2.650000)",
    fill: "#FE89EE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.428125,8.203125 L10.4625,8.203125 L10.4625,10.2539062 C10.4625,10.4157084 10.5926172,10.546875 10.753125,10.546875 L12.496875,10.546875 C12.6573828,10.546875 12.7875,10.4157084 12.7875,10.2539062 L12.7875,8.203125 L14.821875,8.203125 C14.9823828,8.203125 15.1125,8.07195842 15.1125,7.91015625 L15.1125,6.15234375 C15.1125,5.99054158 14.9823828,5.859375 14.821875,5.859375 L12.7875,5.859375 L12.7875,3.80859375 C12.7875,3.64679158 12.6573828,3.515625 12.496875,3.515625 L10.753125,3.515625 C10.5926172,3.515625 10.4625,3.64679158 10.4625,3.80859375 L10.4625,5.859375 L8.428125,5.859375 C8.26761724,5.859375 8.1375,5.99054158 8.1375,6.15234375 L8.1375,7.91015625 C8.1375,8.07195842 8.26761724,8.203125 8.428125,8.203125 Z M20.925,1.7578125 C20.9222067,0.788168212 20.1431371,0.0028158278 19.18125,0 L4.06875,0 C3.10686287,0.0028158278 2.3277933,0.788168212 2.325,1.7578125 L2.325,14.0625 L20.925,14.0625 L20.925,1.7578125 Z M18.6,11.71875 L4.65,11.71875 L4.65,2.34375 L18.6,2.34375 L18.6,11.71875 Z M22.66875,15.234375 L13.8606328,15.234375 C13.83375,15.9598389 13.3262461,16.40625 12.67125,16.40625 L10.4625,16.40625 C9.78352734,16.40625 9.26367187,15.7664795 9.27202734,15.234375 L0.58125,15.234375 C0.260234489,15.234375 0,15.4967082 0,15.8203125 L0,16.40625 C0.00379053344,17.6990813 1.04251133,18.7461789 2.325,18.75 L20.925,18.75 C22.2074887,18.7461789 23.2462095,17.6990813 23.25,16.40625 L23.25,15.8203125 C23.25,15.4967082 22.9897655,15.234375 22.66875,15.234375 L22.66875,15.234375 Z",
    id: "Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMedicalCourse);
export default __webpack_public_path__ + "static/media/icon-medical-course.3233ad0e.svg";
export { ForwardRef as ReactComponent };